export const CATERING_PATH = '/order-catering';
export const FOUNDATION_PATH =
  'https://firehousesubsfoundation.ca/?utm_source=firehousesubs.ca&utm_medium=foundation_link&utm_campaign=foundation_nav';
export const CAREERS_PATH = 'https://careers.firehousesubs.ca';
export const DONATE_PATH =
  'https://www.canadahelps.org/en/charities/firehouse-subs-public-safety-foundation-of-canada/';
